import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Alert
} from '@mui/material';
import { Warning, ExitToApp, Refresh } from '@mui/icons-material';

const SessionTimeoutWarning = ({ 
  open, 
  timeRemaining, 
  onExtendSession, 
  onLogout 
}) => {
  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
  };

  return (
    <Dialog 
      open={open} 
      disableEscapeKeyDown
      disableBackdropClick
      maxWidth="sm" 
      fullWidth
    >
      <DialogTitle>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Warning color="warning" />
          <Typography variant="h6">
            Session Timeout Warning
          </Typography>
        </Box>
      </DialogTitle>

      <DialogContent>
        <Alert severity="warning" sx={{ mb: 2 }}>
          Your session will expire due to inactivity
        </Alert>
        
        <Typography variant="body1" gutterBottom>
          Your session will automatically end in:
        </Typography>
        
        <Box 
          sx={{ 
            textAlign: 'center', 
            p: 2, 
            bgcolor: 'error.light', 
            color: 'error.contrastText',
            borderRadius: 1,
            mb: 2
          }}
        >
          <Typography variant="h4" component="div">
            {formatTime(timeRemaining)}
          </Typography>
        </Box>
        
        <Typography variant="body2" color="text.secondary">
          Click "Stay Logged In" to extend your session, or "Logout Now" to end your session immediately.
        </Typography>
      </DialogContent>

      <DialogActions>
        <Button
          onClick={onLogout}
          color="error"
          variant="outlined"
          startIcon={<ExitToApp />}
        >
          Logout Now
        </Button>
        <Button
          onClick={onExtendSession}
          color="primary"
          variant="contained"
          startIcon={<Refresh />}
          autoFocus
        >
          Stay Logged In
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SessionTimeoutWarning;